import { ActivatedRouteSnapshot, CanActivateChildFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { LocationRefService } from '../../share/services/location-ref.service';
import { Pages, toCommands } from '../../../constants/pages';
import { WindowRefService } from '../../share/services/window-ref.service';
import { isDrupalAnonymousUser } from '../../share/utils/is-drupal-anonymous-user';

export const defaultRouting: CanActivateChildFn = ({ queryParams }: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const location = inject(LocationRefService);
  const windowRef = inject(WindowRefService);
  const pathName = location.nativeLocation.pathname;

  if (pathName.indexOf('/join') !== -1) {
    router.navigate(toCommands(Pages.join), { queryParams });
    return false;
  }

  // A signed-out visitor on the Drupal account page has no account to open; the account
  // route sends anonymous users back here, so this must not send them to /account again.
  if (pathName.indexOf('/account') !== -1 && !isDrupalAnonymousUser(windowRef.nativeWindow?.metaData?.user)) {
    router.navigate(toCommands(Pages.account), { queryParams });
    return false;
  }

  if (pathName.indexOf('/renew') !== -1) {
    router.navigate(toCommands(Pages.renew), { queryParams });
    return false;
  }

  if (pathName.indexOf('/gift') !== -1) {
    router.navigate(toCommands(Pages.giftOffers), { queryParams });
    return false;
  }

  return true;
};

export default defaultRouting;
